<template>
  <v-row
    class="d-flex align-center"
  >
    <v-col
      cols="12"
      sm="6"
    >
      <div
        class="d-flex align-center px-2"
        :class="{'flex-row justify-space-between w-full':$vuetify.breakpoint.smAndDown, 'flex-column': $vuetify.breakpoint.mdAndUp}"
      >
        <p
          class="text-body-1 item text-no-wrap text--darken-3 pl-1 mb-0 pb-0"
        >
          Eingeladene Kontakte
        </p>
        <v-progress-circular
          v-if="!totalInvitationsCount"
          indeterminate
          :size="25"
        />
        <p
          v-else
          class="mb-0 pb-0"
        >
          <b>{{ totalInvitationsCount }}</b>
        </p>
      </div>
    </v-col>
    <v-col
      cols="12"
      sm="6"
    >
      <div
        class="d-flex align-center px-2"
        :class="{'flex-row justify-space-between w-full':$vuetify.breakpoint.smAndDown, 'flex-column': $vuetify.breakpoint.mdAndUp}"
      >
        <p
          class="text-body-1 item text-no-wrap text--darken-3 pl-1 mb-0 pb-0"
        >
          Davon mit Interaktionen
        </p>
        <v-progress-circular
          v-if="!totalInvitationsCount"
          indeterminate
          :size="25"
        />
        <p
          v-else
          class="mb-0 pb-0"
        >
          <b>{{ interactedInvitationsCount }}</b>
        </p>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    totalInvitationsCount: {
      type: Number,
      default: 0
    },
    interactedInvitationsCount: {
      type: Number,
      default: 0
    }
  }
}
</script>
